import tooltipStyles from "../../styles/tooltip.module.css";
import StandardButton from "../UI/buttons/StandardButton";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";
import { bagstageApplications } from "../../utils/commonUtil";
import StandardLinkButton from "../UI/buttons/StandardLinkButton";
import URLService from "../../service/urlService";

export default function SettingsOptionButton() {
  const { t } = useTranslation();
  const { kcObject } = useAppSelector((state) => state.authenticationSlice);
  const { enabledProducts } = useAppSelector(
    (state) => state.enabledProductsSlice
  );

  return (
    <>
      {enabledProducts?.includes(bagstageApplications.userManagement) && (
        <StandardLinkButton
          to={URLService.generateRedirectUrl(
            window._env_.REACT_APP_USER_MANAGEMENT_URL
          )}
          classes={`${tooltipStyles.tooltipOption} ${tooltipStyles.languageOptionDefaultBg}`}
          variant="tertiary"
        >
          {t("user-management")}
        </StandardLinkButton>
      )}
      <StandardButton
        onClick={() => kcObject?.logout()}
        classes={`${tooltipStyles.tooltipOption} ${tooltipStyles.languageOptionDefaultBg}`}
        variant="tertiary"
      >
        {t("log-out")}
      </StandardButton>
    </>
  );
}
